import { ApCounterparties } from '@/features/ap_counterparties/index';
import { r2wc } from '@/wc/helper/render';

export const AddNewCounterparty = r2wc(ApCounterparties, {
  shadow: 'open',
});
